import { StateUtils } from '@spartacus/core';
import { REVOKE_MANAGER } from '../my-account-state';

export const REVOKE_PERSONAL_MANAGER = '[My Account] Revoke Manager';
export const REVOKE_PERSONAL_MANAGER_SUCCESS = '[My Account] Revoke Manager Success';
export const REVOKE_PERSONAL_MANAGER_FAIL = '[My Account] Revoke Manager Fail';

export class RevokePersonalManager extends StateUtils.EntityLoadAction {
  readonly type = REVOKE_PERSONAL_MANAGER;

  constructor(public payload: string) {
    super(REVOKE_MANAGER, payload);
  }
}
export class RevokePersonalManagerSuccess extends StateUtils.EntitySuccessAction {
  readonly type = REVOKE_PERSONAL_MANAGER_SUCCESS;

  constructor(public personalManagerId: string) {
    super(REVOKE_MANAGER, personalManagerId);
  }
}
export class RevokePersonalManagerFail extends StateUtils.EntityFailAction {
  readonly type = REVOKE_PERSONAL_MANAGER_FAIL;

  constructor(
    public personalManagerId: string,
    public error: unknown,
  ) {
    super(REVOKE_MANAGER, personalManagerId);
  }
}
